import React, { useEffect, useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import { Badge } from "./ui/badge";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AdminScanFeedbackTab = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const load = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/scan/feedback`);
      if (!res.ok) throw new Error("Failed to load feedback");
      setData(await res.json());
    } catch (e) {
      setError(e.message);
    }
  };

  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this feedback?")) return;
    const res = await fetch(`${BACKEND_URL}/api/scan/feedback/${id}`, { method: "DELETE" });
    if (!res.ok) { setError("Could not delete feedback"); return; }
    load();
  };

  if (error) return <p className="text-sm text-red-600" data-testid="admin-scan-feedback-error">{error}</p>;
  if (!data) return <Loader2 className="h-5 w-5 animate-spin text-gray-400" />;

  return (
    <div className="space-y-3" data-testid="admin-scan-feedback-tab">
      <div className="flex gap-2 text-xs" data-testid="admin-scan-feedback-counts">
        <Badge variant="outline">Total {data.total}</Badge>
        <Badge variant="outline">Guests {data.guest_count}</Badge>
        <Badge variant="outline">Subscribers {data.subscriber_count}</Badge>
      </div>
      {data.comments.length === 0 && <p className="text-sm text-gray-500">No feedback yet.</p>}
      {data.comments.map((c) => (
        <div key={c.id} className="rounded-lg border border-gray-200 p-3 bg-white" data-testid={`admin-scan-feedback-${c.id}`}>
          <div className="flex items-center justify-between gap-2 mb-1">
            <div className="flex items-center gap-2 text-[11px] text-gray-500">
              <Badge className={c.user_type === "subscriber" ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-700"}>
                {c.user_type}
              </Badge>
              {c.user_email && <span>{c.user_email}</span>}
              <span>{new Date(c.created_at).toLocaleString()}</span>
            </div>
            <button onClick={() => remove(c.id)} className="text-gray-400 hover:text-red-600" data-testid={`admin-scan-feedback-delete-${c.id}`}>
              <Trash2 className="h-3.5 w-3.5" />
            </button>
          </div>
          <p className="text-sm text-gray-800 whitespace-pre-wrap">{c.comment}</p>
        </div>
      ))}
    </div>
  );
};
